var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:_vm.name,style:({color:_vm.colors,fontSize:_vm.size+'px'}),on:{"click":function($event){$event.stopPropagation();return _vm.clickIcon.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }